/* eslint-disable no-debugger */
import React, { Fragment } from "react";

import useClubMeets from "./UseClubMeetsV3";

import ClubMeetsGrid from "./ClubMeetsGridV3";

import ReportPeriodDropdown from "@usas/ui-web/components/dropdowns/reportPeriodDropdown/ReportPeriodDropdown";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import Headings from "@usas/ui-web/components/headings/Headings";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import Constants from "@usas/ui-web/utils/Constants";
import ViewReport from "@usas/ui-web/components/embeddedReports/ViewReport";

const ClubMeetsV3 = () => {
  const {
    clubMeetsState,
    gridState,
    formState,
    errorState,
    deleteModalState,
    viewState,
    setViewState,
    isSaving,
    isLoading,
    organizationId,
    clubOrgUnitId,
    onRequestV3ButtonClicked,
    onDeleteClicked,
    onReportPeriodChanged,
    onUploadClicked,
    onMeetReconClicked,
    onModalCancelClicked,
    onModalDeleteClicked,
    onViewMeetAnnouncementReport,
    onViewUploadResultsInvoice,
    onEdit,
    onGoToCart,
    USAS_ORG_UNIT_ID,
    INITIAL_VIEW_STATE
  } = useClubMeets();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>National Meet Sanctions</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-8 usas-extra-top-margin">
          {/* <ActionIntraPageButton onClick={onRequestButtonClicked}>Request Meet Sanction</ActionIntraPageButton>&nbsp; */}
          <ActionIntraPageButton onClick={onRequestV3ButtonClicked}>Request Meet Sanction</ActionIntraPageButton>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <ReportPeriodDropdown
            label="Report Period"
            name="reportPeriodId"
            value={formState.reportPeriodId}
            error={errorState.reportPeriodId}
            message={errorState.reportPeriodId}
            onChange={(value, valueLabel) => onReportPeriodChanged(value, valueLabel)}
            organizationId={organizationId} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubMeetsGrid
            data={gridState}
            clubOrgUnitId={clubOrgUnitId}
            isLoading={clubMeetsState.isArrayLoading}
            onUploadClicked={onUploadClicked}
            onMeetReconClicked={onMeetReconClicked}
            onDeleteClicked={onDeleteClicked}
            onViewMeetAnnouncementReport={onViewMeetAnnouncementReport}
            onViewUploadResultsInvoice={onViewUploadResultsInvoice}
            onEdit={onEdit}
            onGoToCart={onGoToCart}
            USAS_ORG_UNIT_ID={USAS_ORG_UNIT_ID}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Delete Meet?'}
        displayPopUp={deleteModalState.displayPopUp}
        onModalCanceled={onModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>Meet:</b> {deleteModalState.meetName}</p>
            <p><b>Dates:</b> {deleteModalState.meetDates}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onModalDeleteClicked}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      {viewState.showReport === true &&
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <ViewReport
              reportInfoId={viewState.reportInfoId}
              reportParameters={viewState.reportParameters}
              onBackToGrid={() => setViewState({ INITIAL_VIEW_STATE })} />
          </div>
        </div>
      }
    </Fragment>
  );
};

export default ClubMeetsV3;